import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { useState } from "react";

import { EditDialog } from "./dialog";

export const EditButton = ({ groupId, recipientId, recipient }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "4px",
					border: "1px solid rgba(224, 224, 224, 1)",
					borderRadius: "4px",
					cursor: "pointer",
					height: "27px",
					width: "27px",
				}}
				onClick={handleClickOpen}
			>
				<EditIcon sx={{ fontSize: "17px" }} />
			</Box>
			<EditDialog
				open={open}
				onClose={handleClose}
				groupId={groupId}
				recipientId={recipientId}
				recipient={recipient}
			/>
		</>
	);
};
